import { Component, Inject, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-users-drivers-view",
  templateUrl: "./admin-users-drivers-view.component.html",
  styleUrls: ["./admin-users-drivers-view.component.css"],
})
export class AdminUsersDriversViewComponent implements OnInit {
  driverData: any;
  editDriverProfile: boolean = false;
  editDriverFrom: FormGroup;
  loading: boolean = false;
  file: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  uploadInsurance: boolean = true;
  insuranceImageName: any;
  updateInsurance: boolean = true;
  truckImage: any;
  viewDriver: boolean = true;
  uploaddrivingLicense: boolean = true;
  drivinglicenseImageName: any;
  truckList: any = [];
  token: any;
  today = new Date();
  truckDropDownDispaly: boolean = true;
  truckNumber: any;
  perPage: any = 10;
  page: any = 1;
  driverMobile: any = -1;
  constructor(
    private matdialogref: MatDialogRef<AdminUsersDriversViewComponent>,
    private matDialog: MatDialog,
    private services: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.driverData = this.data;
    this.token = localStorage.getItem("adminToken");

    this.editDriverFrom = this.formBuilder.group({
      insurance_expiry: [""],
      insurance: [""],
      driving_license_expiry: [""],
      driving_license: [""],
      name: [""],
      email: [""],
      address_line: [""],
      area: [""],
      city: [""],
      state: [""],
      pincode: [""],
      mobile: [""],
      gst: [""],
      truck_number: [""],
      driving_license_number: [""],
      license_expiry_date: [""],
      emergency_contact: [""],
    });
    this.insuranceImg();
    this.drivinglicenseImg();
    this.getTrucks();
    let truckId = this.driverData.registerInfo[0].truck_id;
    this.truckNumber = this.truckList.find(
      (element: any) => Number(element._id) == truckId
    );
  }
  close() {
    this.matdialogref.close();
  }

  // never used 
  driverGet() {
    this.services
      .getUsersDriver(this.token, this.perPage, this.page, this.driverMobile)
      .subscribe(
        (response: any) => {
          const driverdata = response.body.data;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public getTrucks() {
    this.services.GetAvailableTrucks(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  editDriver() {
    this.editDriverProfile = true;
    this.viewDriver = false;
    this.insuranceImg();
    this.drivinglicenseImg();
    (this.truckImage = this.driverData.registerInfo[0]?.profile_image),
      (this.drivinglicenseImageName =
        this.driverData.registerInfo[0]?.documents?.driving_license),
      (this.insuranceImageName =
        this.driverData.registerInfo[0]?.documents?.insurance);
    this.editDriverFrom.patchValue({
      name: this.driverData.registerInfo[0]?.contact_details.name,
      address_line:
        this.driverData.registerInfo[0]?.contact_details.address_line,
      area: this.driverData.registerInfo[0]?.contact_details.area,
      city: this.driverData.registerInfo[0]?.contact_details.city,
      state: this.driverData.registerInfo[0]?.contact_details.state,
      pincode: this.driverData.registerInfo[0]?.contact_details.pincode,
      mobile: this.driverData.registerInfo[0]?.contact_details.mobile,
      gst: this.driverData.registerInfo[0]?.contact_details.gst,
      license_expiry_date: this.driverData.registerInfo[0]?.license_expiry_date,
      driving_license:
        this.driverData.registerInfo[0]?.documents.driving_license,
      insurance: this.driverData.registerInfo[0]?.documents?.insurance,
      driving_license_expiry:
        this.driverData.registerInfo[0]?.documents?.driving_license_expiry,
      driving_license_number:
        this.driverData.registerInfo[0]?.driving_license_number,
      insurance_expiry:
        this.driverData.registerInfo[0]?.documents?.insurance_expiry,
      emergency_contact: this.driverData.registerInfo[0]?.emergency_contact,
      truck_id: this.driverData.registerInfo[0]?.truck_id,
    });
  }
  UpdateDriver() {
    let drivinglic = this.editDriverFrom.value.driving_license_number;
    if (!drivinglic) {
      this.snackBar.open("Please enter driving license number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let expiryDate = this.editDriverFrom.value.license_expiry_date;
    if (!expiryDate) {
      this.snackBar.open("Please select expiry date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let truckAssign = this.editDriverFrom.value.truck_number;
    if (!truckAssign) {
      this.snackBar.open("Please select truck assign number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let emergency = this.editDriverFrom.value.emergency_contact;
    if (!emergency) {
      this.snackBar.open("Please enter emergency contact ", "Fail", {
        duration: 5000,
      });
      return;
    }
    let name = this.editDriverFrom.value.name;
    if (!name) {
      this.snackBar.open("Please enter name", "Fail", {
        duration: 5000,
      });
      return;
    }
    let address = this.editDriverFrom.value.address_line;
    if (!address) {
      this.snackBar.open("Please enter address", "Fail", {
        duration: 5000,
      });
      return;
    }
    let area = this.editDriverFrom.value.area;
    if (!area) {
      this.snackBar.open("Please enter area", "Fail", {
        duration: 5000,
      });
      return;
    }
    let city = this.editDriverFrom.value.city;
    if (!city) {
      this.snackBar.open("Please enter city", "Fail", {
        duration: 5000,
      });
      return;
    }
    let state = this.editDriverFrom.value.state;
    if (!state) {
      this.snackBar.open("Please enter state", "Fail", {
        duration: 5000,
      });
      return;
    }
    let pincode = this.editDriverFrom.value.pincode;
    if (!pincode) {
      this.snackBar.open("Please enter pincode", "Fail", {
        duration: 5000,
      });
      return;
    }
    let mobile = this.editDriverFrom.value.mobile;
    if (!mobile) {
      this.snackBar.open("Please enter contact number", "Fail", {
        duration: 5000,
      });
      return;
    }
    const documentObj = {
      driving_license: this.editDriverFrom.value.driving_license,
      driving_license_expiry: this.editDriverFrom.value.driving_license_expiry,
      insurance: this.editDriverFrom.value.insurance,
      insurance_expiry: this.editDriverFrom.value.insurance_expiry,
    };
    const contactObj = {
      name: this.editDriverFrom.value.name,
      address_line: this.editDriverFrom.value.address_line,
      area: this.editDriverFrom.value.area,
      city: this.editDriverFrom.value.city,
      state: this.editDriverFrom.value.state,
      pincode: Number(this.editDriverFrom.value.pincode),
      mobile: this.editDriverFrom.value.mobile,
      gst: this.editDriverFrom.value.gst,
    };
    const driverObj = {
      driving_license_number: this.editDriverFrom.value.driving_license_number,
      license_expiry_date: this.editDriverFrom.value.license_expiry_date,
      documents: documentObj,
      contact_details: contactObj,
      truck_id: this.editDriverFrom.value.truck_number,
      emergency_contact: Number(this.editDriverFrom.value.emergency_contact),
      profile_image: this.truckImage,
    };
    if (this.editDriverFrom.value.driving_license == "" || undefined || null) {
      this.snackBar.open("Please upload driver license image", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.editDriverFrom.value.insurance == "") {
      this.snackBar.open("Please upload insurance image", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.driverData.profile_image == "") {
      this.snackBar.open("Please upload driver profile image", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.services
      .driverUpdate(driverObj, this.token, this.driverData.ref_id)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.driverGet();
            this.matdialogref.close();
            this.snackBar.open(
              "Driver details updated successfully",
              "Success",
              {
                duration: 5000,
              }
            );
            window.location.reload();
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public onChange(event: any, type: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          if (type == "Insurance") {
            this.uploadInsurance = false;
            this.updateInsurance = false;
            this.insuranceImageName = this.file.name;
            this.editDriverFrom.value.insurance = response.body.image_link;
          }
          if (type == "driverlicense") {
            this.uploaddrivingLicense = false;
            this.drivinglicenseImageName = this.file.name;
            this.editDriverFrom.value.driving_license =
              response.body.image_link;
          }
          if (type == "Truck") {
            this.truckImage = response.body.image_link;
          }
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  insuranceImg() {
    let insuranceArray =
      this.data.registerInfo[0]?.documents?.insurance.split("20");
    this.insuranceImageName = insuranceArray[2];
  }

  drivinglicenseImg() {
    let drivingArray =
      this.driverData.registerInfo[0]?.documents?.driving_license?.split("20");
    this.drivinglicenseImageName = drivingArray[2];
  }

  removeImg(event: any, type: any) {
    if (type == "driverlicense") {
      this.uploaddrivingLicense = true;
      this.editDriverFrom.value.driving_license = "";
    }
    if (type == "insurance") {
      this.uploadInsurance = true;
      this.editDriverFrom.value.insurance = "";
    }
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
